import { createBlocksModel } from '@wix/yoshi-flow-editor/blocks';

export default createBlocksModel({
  widgetName: 'Post Title',
  props: {},
  methods: {
    initialize: {
      description: 'Initialize the post title',
    },
  },
  events: {},
});
